export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California",
  "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida",
  "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
  "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
  "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
  "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
  "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
  "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin",
  "Wyoming",
];

export const AU_STATES = [
  "Australian Capital Territory", "New South Wales", "Northern Territory", "Queensland",
  "South Australia", "Tasmania", "Victoria", "Western Australia",
];

/**
 * Where an instructor teaches, for onboarding. The chosen region is stored in
 * the user's `state` field whatever the country, and "Elsewhere" takes it as
 * typed text. Mirrors `mobile/src/data/locations.js`.
 */
export const COUNTRY_OPTIONS = [
  { id: "US", label: "United States", regionLabel: "State", regions: US_STATES, cityExample: "Nashville" },
  { id: "AU", label: "Australia", regionLabel: "State or territory", regions: AU_STATES, cityExample: "Melbourne" },
  { id: "other", label: "Elsewhere", regionLabel: "Region and country", regions: null, cityExample: "Toronto" },
];

/**
 * The country to start on, from the browser's language region: Australia for
 * an Australian locale, the US for a US one or none, and Elsewhere for any
 * other. Only a starting point; the person can change it.
 *
 * @param {string} [locale] - A BCP 47 tag; defaults to the browser's.
 * @returns {"US"|"AU"|"other"}
 */
export function defaultCountry(locale) {
  const tag = locale ?? (typeof navigator !== "undefined" ? navigator.language : "");
  const region = String(tag || "")
    .split(/[-_]/)
    .slice(1)
    .find((part) => /^[A-Za-z]{2}$/.test(part));
  if (!region) return "US";
  const code = region.toUpperCase();
  if (code === "AU") return "AU";
  if (code === "US") return "US";
  return "other";
}

/**
 * The country a stored region belongs to, so the profile editor opens on the
 * list it came from. A region on the US list is the US's and one on the
 * Australian list is Australia's; any other text was typed under Elsewhere.
 * With no region stored it starts where onboarding would. Mirrors
 * `mobile/src/data/locations.js`.
 *
 * @param {string|null} [state] - The user's stored `state` field.
 * @param {string} [locale] - Passed to `defaultCountry` when there is no region.
 * @returns {"US"|"AU"|"other"}
 */
export function countryForRegion(state, locale) {
  const region = typeof state === "string" ? state.trim() : "";
  if (!region) return defaultCountry(locale);
  if (US_STATES.includes(region)) return "US";
  if (AU_STATES.includes(region)) return "AU";
  return "other";
}
